import { render } from "./MainMenu.vue?vue&type=template&id=cf0a78ba&bindings={\"config\":\"setup\",\"myAvatars\":\"setup\",\"channels\":\"setup\",\"ownedPercent\":\"setup\",\"settingsDropdown\":\"setup\"}"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"

import "./MainMenu.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script